import { PageLoadEvent } from '../../../types/events';
import { Ecommerce } from '../../../types/datalayer/pageview';
import { searchImpressions, formatFilters } from './helpers';
import { PageViewEvent } from '../../../types/datalayer/pageview';

export default (pageload: PageLoadEvent): PageViewEvent => {
  const search = pageload.detail?.search || {};
  const { results, limit, offset, sortBy } = search;
  const selectedAggregations = search.selectedAggregations || [];
  const productIds = search.productIds || [];
  const content = search.content || {};
  const suggestions = content.suggestions || [];
  const ecommerce = { impressions: searchImpressions(productIds) } as Ecommerce;

  return {
    searchTerm: content.term?.toLocaleLowerCase(),
    searchResults: results?.toString(),
    searchProducts: productIds.join(),
    searchActualTerm: suggestions[0]?.term,
    searchFilters: formatFilters(selectedAggregations),
    searchLimit: limit,
    searchOffset: offset == null ? 1 : offset,
    searchSortBy: sortBy,
    searchImpressions: productIds.length > 0 ? 1 : 0,
    didYouMeanUsed: suggestions[0]?.used ? 1 : 0,
    didYouMeanNotUsed: content.used ? 1 : 0,
    didYouMean: suggestions.length > 0 ? 1 : 0,
    ecommerce,
  } as PageViewEvent;
};
